import * as React from 'react';
import {Glyph} from '../../types/Glyph';
import {MouseEventHandler, ReactNode, useMemo} from 'react';
import styles from './Icon.module.css';
import RenderHelpers from '../../../shared-ui/helpers/RenderHelpers';
import Helpers from '../../../shared-common/helpers/Helpers';

import {ReactComponent as Accept16Glyph} from './glyphs/accept-16.svg';
import {ReactComponent as AcceptGlyph} from './glyphs/accept.svg';
import {ReactComponent as AddGlyph} from './glyphs/add.svg';
import {ReactComponent as Add16Glyph} from './glyphs/add-16.svg';
import {ReactComponent as BackFilledGlyph} from './glyphs/back-filled.svg';
import {ReactComponent as BackGlyph} from './glyphs/back.svg';
import {ReactComponent as Busy16Glyph} from './glyphs/busy-16.svg';
import {ReactComponent as BusyGlyph} from './glyphs/busy.svg';
import {ReactComponent as Calendar16Glyph} from './glyphs/calendar-16.svg';
import {ReactComponent as CancelGlyph} from './glyphs/cancel.svg';
import {ReactComponent as Cancel16Glyph} from './glyphs/cancel-16.svg';
import {ReactComponent as Checked16Glyph} from './glyphs/checked-16.svg';
import {ReactComponent as CollapseGlyph} from './glyphs/collapse.svg';
import {ReactComponent as Collapse24Glyph} from './glyphs/collapse-24.svg';
import {ReactComponent as CollapseAll24Glyph} from './glyphs/collapse-all-24.svg';
import {ReactComponent as CollapseLevel24Glyph} from './glyphs/collapse-level-24.svg';
import {ReactComponent as ExpandAll24Glyph} from './glyphs/expand-all-24.svg';
import {ReactComponent as ExpandLevel24Glyph} from './glyphs/expand-level-24.svg';
import {ReactComponent as ExpandCollapse24Glyph} from './glyphs/expand-collapse-24.svg';
import {ReactComponent as Copy16Glyph} from './glyphs/copy-16.svg';
import {ReactComponent as Delete16Glyph} from './glyphs/delete-16.svg';
import {ReactComponent as Delete16FilledGlyph} from './glyphs/delete-16-filled.svg';
import {ReactComponent as Delete24Glyph} from './glyphs/delete-24.svg';
import {ReactComponent as Delete24FilledGlyph} from './glyphs/delete-24-filled.svg';
import {ReactComponent as Download16Glyph} from './glyphs/download-16.svg';
import {ReactComponent as DraggableGlyph} from './glyphs/draggable.svg';
import {ReactComponent as Edit16Glyph} from './glyphs/edit-16.svg';
import {ReactComponent as EditFilled16Glyph} from './glyphs/edit-filled-16.svg';
import {ReactComponent as Edit24Glyph} from './glyphs/edit-24.svg';
import {ReactComponent as ExpandGlyph} from './glyphs/expand.svg';
import {ReactComponent as Expand24Glyph} from './glyphs/expand-24.svg';
import {ReactComponent as ForwardFilledGlyph} from './glyphs/forward-filled.svg';
import {ReactComponent as ForwardFilled16Glyph} from './glyphs/forward-filled-16.svg';
import {ReactComponent as Forward16Glyph} from './glyphs/forward-16.svg';
import {ReactComponent as ForwardGlyph} from './glyphs/forward.svg';
import {ReactComponent as RowMarkerGlyph} from './glyphs/row-marker-24.svg';
import {ReactComponent as RowMarkerFilledGlyph} from './glyphs/row-marker-filled-24.svg';
import {ReactComponent as RowMarkerSolid16Glyph} from './glyphs/row-marker-solid-16.svg';
import {ReactComponent as PasteGlyph} from './glyphs/paste.svg';
import {ReactComponent as Save16Glyph} from './glyphs/save-16.svg';
import {ReactComponent as SaveGlyph} from './glyphs/save.svg';
import {ReactComponent as SubmitFilledGlyph} from './glyphs/submit-filled.svg';
import {ReactComponent as SubmitGlyph} from './glyphs/submit.svg';
import {ReactComponent as Submit16Glyph} from './glyphs/submit-16.svg';
import {ReactComponent as Submit16FilledGlyph} from './glyphs/submit-filled-16.svg';
import {ReactComponent as EmailFilled16Glyph} from './glyphs/email-filled-16.svg';
import {ReactComponent as Email16Glyph} from './glyphs/email-16.svg';
import {ReactComponent as AiGlyph} from './glyphs/ai.svg';
import {ReactComponent as SadGlyph} from './glyphs/sad.svg';
import {ReactComponent as HappyGlyph} from './glyphs/happy.svg';
import {ReactComponent as Document24Glyph} from './glyphs/document-24.svg';
import {ReactComponent as Document24FilledGlyph} from './glyphs/document-24-filled.svg';
import {ReactComponent as SearchGlyph} from './glyphs/search.svg';
import {ReactComponent as SearchGlyph16} from './glyphs/search-16.svg';
import {ReactComponent as Structure16Glyph} from './glyphs/structure-16.svg';
import {ReactComponent as Structure24Glyph} from './glyphs/structure-24.svg';
import {ReactComponent as StructureUnit24Glyph} from './glyphs/structure-unit-24.svg';
import {ReactComponent as Employee16Glyph} from './glyphs/employee-16.svg';
import {ReactComponent as Print16Glyph} from './glyphs/print-16.svg';import {ReactComponent as Employee24Glyph} from './glyphs/employee-filled-24.svg';
import {ReactComponent as ExcelDocument16Glyph} from './glyphs/excel-document-16.svg';
import {ReactComponent as ExcelDocument24Glyph} from './glyphs/excel-document-24.svg';
import {ReactComponent as Ellipsis16Glyph} from './glyphs/ellipsis-16.svg';
import {ReactComponent as Ellipsis24Glyph} from './glyphs/ellipsis-24.svg';
import {ReactComponent as Bold16Glyph} from './glyphs/bold-16.svg';
import {ReactComponent as Italic16Glyph} from './glyphs/italic-16.svg';
import {ReactComponent as Underline16Glyph} from './glyphs/underline-16.svg';
import {ReactComponent as InsertSnippet16Glyph} from './glyphs/insert-snippet-16.svg';
import {ReactComponent as TextAlignLeft16Glyph} from './glyphs/text-align-left-16.svg';
import {ReactComponent as TextAlignCenter16Glyph} from './glyphs/text-align-center-16.svg';
import {ReactComponent as TextAlignRight16Glyph} from './glyphs/text-align-right-16.svg';
import {ReactComponent as TextAlignJustify16Glyph} from './glyphs/text-align-justify-16.svg';
import {ReactComponent as Link16Glyph} from './glyphs/link-16.svg';
import {ReactComponent as Refresh16Glyph} from './glyphs/refresh-16.svg';
import {ReactComponent as Picture16Glyph} from './glyphs/picture-16.svg';
import {ReactComponent as Bullet16Glyph} from './glyphs/bullet-16.svg';
import {ReactComponent as Number16Glyph} from './glyphs/number-16.svg';
import {ReactComponent as FontColor16Glyph} from './glyphs/font-color-16.svg';
import {ReactComponent as BackgroundColor16Glyph} from './glyphs/background-color-16.svg';
import {ReactComponent as Subscript16Glyph} from './glyphs/subscript-16.svg';
import {ReactComponent as Superscript16Glyph} from './glyphs/superscript-16.svg';
import {ReactComponent as LeftToRight16Glyph} from './glyphs/left-to-right-16.svg';
import {ReactComponent as RightToLeft16Glyph} from './glyphs/right-to-left-16.svg';
import {ReactComponent as Tick16Glyph} from './glyphs/tick-16.svg';
import {ReactComponent as ClearFormatting16Glyph} from './glyphs/clear-formatting-16.svg';
import {ReactComponent as Feedback16Glyph} from './glyphs/feedback-16.svg';
import {ReactComponent as FeedbackSolid16Glyph} from './glyphs/feedback-solid-16.svg';
import {ReactComponent as FeedbackReceivedSolid16Glyph} from './glyphs/feedback-received-solid-16.svg';
import {ReactComponent as StatusPending16Glyph} from './glyphs/status-pending-16.svg';
import {ReactComponent as StatusPending24Glyph} from './glyphs/status-pending-24.svg';
import {ReactComponent as Bell16Glyph} from './glyphs/bell-16.svg';
import {ReactComponent as Bell24Glyph} from './glyphs/bell-24.svg';
import {ReactComponent as StatusCompleted16Glyph} from './glyphs/status-completed-16.svg';
import {ReactComponent as StatusCompletedFilled16Glyph} from './glyphs/status-completed-filled-16.svg';
import {ReactComponent as StatusCompleted24Glyph} from './glyphs/status-completed-24.svg';
import {ReactComponent as StatusRunning16Glyph} from './glyphs/status-running-16.svg';
import {ReactComponent as StatusRunning24Glyph} from './glyphs/status-running-24.svg';
import {ReactComponent as Previous24Glyph} from './glyphs/previous-24.svg';
import {ReactComponent as PreviousSkip24Glyph} from './glyphs/previous-skip-24.svg';
import {ReactComponent as Next24Glyph} from './glyphs/next-24.svg';
import {ReactComponent as NextSkip24Glyph} from './glyphs/next-skip-24.svg';
import {ReactComponent as Previous16Glyph} from './glyphs/previous-16.svg';
import {ReactComponent as PreviousSkip16Glyph} from './glyphs/previous-skip-16.svg';
import {ReactComponent as Next16Glyph} from './glyphs/next-16.svg';
import {ReactComponent as NextSkip16Glyph} from './glyphs/next-skip-16.svg';
import {GlyphStyle} from '../../types/GlyphStyle';

export interface IconProps {
  className?: string;
  style?: React.CSSProperties;
  glyph: Glyph | ReactNode;
  glyphStyle?: GlyphStyle;
  size?: 16 | 24 | 32 | number;
  color?: string;
  onMouseOver?: MouseEventHandler<HTMLDivElement>;
  onMouseOut?: MouseEventHandler<HTMLDivElement>;
}

export const Icon = (props: IconProps) => {
  const contents = useMemo(
    () => {
      if (typeof props.glyph !== 'string') {
        return props.glyph;
      }

      const glyphStyle = Helpers.ifNil(props.glyphStyle, 'outline');
      const isFilled = glyphStyle === 'solid';

      switch (props.glyph) {
        case 'accept':
          switch (props.size) {
            case 16:
              return <Accept16Glyph/>;
            default:
            case 24:
              return <AcceptGlyph/>;
          }
        case 'add':
          switch (props.size) {
            case 16:
              return <Add16Glyph/>;
            default:
            case 24:
              return <AddGlyph/>;
          }
        case 'back':
          return isFilled ? <BackFilledGlyph/> : <BackGlyph/>;
        case 'busy':
          switch (props.size) {
            case 16:
              return <Busy16Glyph/>;
            default:
            case 24:
              return <BusyGlyph/>;
          }
        case 'calendar':
          switch (props.size) {
            case 16:
              return <Calendar16Glyph/>;
            default:
            case 24:
              return <Calendar16Glyph/>;
          }
        case 'cancel':
          switch (props.size) {
            case 16:
              return <Cancel16Glyph/>;
            default:
            case 24:
              return <CancelGlyph/>;
          }
        case 'checked':
          switch (props.size) {
            case 16:
              return <Checked16Glyph/>;
            default:
            case 24:
              return <Checked16Glyph/>;
          }
        case 'collapse':
          switch (props.size) {
            case 16:
              return <CollapseGlyph/>;
            default:
            case 24:
              return <Collapse24Glyph/>;
          }
        case 'collapse-all':
          return <CollapseAll24Glyph/>;
        case 'collapse-level':
          return <CollapseLevel24Glyph/>;
        case 'expand-all':
          return <ExpandAll24Glyph/>;
        case 'expand-level':
          return <ExpandLevel24Glyph/>;
        case 'expand-collapse':
          return <ExpandCollapse24Glyph/>;
        case 'delete':
          switch (props.size) {
            case 16:
              return isFilled ? <Delete16FilledGlyph/> : <Delete16Glyph/>;
            default:
            case 24:
              return isFilled ? <Delete24FilledGlyph/> : <Delete24Glyph/>;
          }
        case 'copy':
          return <Copy16Glyph/>;
        case 'download':
          switch (props.size) {
            case 16:
              return <Download16Glyph/>;
            default:
            case 24:
              return isFilled ? <Delete24FilledGlyph/> : <Delete24Glyph/>;
          }
        case 'draggable':
          return <DraggableGlyph/>;
        case 'edit':
          switch (props.size) {
            case 16:
              return isFilled ? <EditFilled16Glyph/> : <Edit16Glyph/>;
            default:
            case 24:
              return <Edit24Glyph/>;
          }
        case 'expand':
          switch (props.size) {
            case 16:
              return <ExpandGlyph/>;
            default:
            case 24:
              return <Expand24Glyph/>;
          }
        case 'forward':
          switch (props.size) {
            case 16:
              return isFilled ? <ForwardFilled16Glyph/> : <Forward16Glyph/>;
            default:
            case 24:
              return isFilled ? <ForwardFilledGlyph/> : <ForwardGlyph/>;
          }
        case 'paste':
          return <PasteGlyph/>;
        case 'save':
          switch (props.size) {
            case 16:
              return <Save16Glyph/>;
            default:
            case 24:
              return <SaveGlyph/>;
          }
        case 'submit':
          switch (props.size) {
            case 16:
              return isFilled ? <Submit16FilledGlyph/> : <Submit16Glyph/>;
            default:
              return isFilled ? <SubmitFilledGlyph/> : <SubmitGlyph/>;
          }
        case 'email-filled':
          return <EmailFilled16Glyph/>;
        case 'email':
          return <Email16Glyph/>;
        case 'ai':
          return <AiGlyph/>;        case 'sad':
          return <SadGlyph/>;
        case 'happy':
          return <HappyGlyph/>;
        case 'document':
          return isFilled ? <Document24FilledGlyph/> : <Document24Glyph/>;
        case 'search':
          switch (props.size) {
            case 16:
              return <SearchGlyph16/>;
            default:
            case 24:
              return <SearchGlyph/>;
          }
        case 'row-marker':
          return <RowMarkerGlyph/>;
        case 'row-marker-filled':
          switch (props.size) {
            case 16:
              return <RowMarkerSolid16Glyph/>;
            default:
            case 24:
              return <RowMarkerFilledGlyph/>;
          }
        case 'structure':
          switch (props.size) {
            case 16:
              return <Structure16Glyph/>;
            default:
            case 24:
              return <Structure24Glyph/>;
          }
        case 'structure-unit':
          return <StructureUnit24Glyph/>;
        case 'employee':
          switch (props.size) {
            case 16:
              return <Employee16Glyph/>;
            default:
            case 24:
              return <Employee24Glyph/>;
          }
        case 'print':
          return <Print16Glyph/>;
        case 'excel-document':
          switch (props.size) {
            case 16:
              return isFilled ? <ExcelDocument16Glyph/> : <ExcelDocument16Glyph/>;
            default:
            case 24:
              return isFilled ? <ExcelDocument24Glyph/> : <ExcelDocument24Glyph/>;
          }
        case 'ellipsis':
          switch (props.size) {
            case 16:
              return <Ellipsis16Glyph/>;
            default:
            case 24:
              return <Ellipsis24Glyph/>;
          }
        case 'bold':
          return <Bold16Glyph/>;
        case 'italic':
          return <Italic16Glyph/>;
        case 'underline':
          return <Underline16Glyph/>;
        case 'insert-snippet':
          return <InsertSnippet16Glyph/>;
        case 'text-align-left':
          return <TextAlignLeft16Glyph/>;
        case 'text-align-center':
          return <TextAlignCenter16Glyph/>;
        case 'text-align-right':
          return <TextAlignRight16Glyph/>;
        case 'text-align-justify':
          return <TextAlignJustify16Glyph/>;
        case 'link':
          return <Link16Glyph/>;
        case 'refresh':
          return <Refresh16Glyph/>;
        case 'picture':
          return <Picture16Glyph/>;
        case 'bullet':
          return <Bullet16Glyph/>;
        case 'number':
          return <Number16Glyph/>;
        case 'font-color':
          return <FontColor16Glyph/>;
        case 'background-color':
          return <BackgroundColor16Glyph/>;
        case 'subscript':
          return <Subscript16Glyph/>;
        case 'superscript':
          return <Superscript16Glyph/>;
        case 'left-to-right':
          return <LeftToRight16Glyph/>;
        case 'right-to-left':
          return <RightToLeft16Glyph/>;
        case 'tick':
          return <Tick16Glyph/>;
        case 'clear-formatting':
          return <ClearFormatting16Glyph/>;
        case 'feedback':
          return <Feedback16Glyph/>;
        case 'feedback-solid':
          return <FeedbackSolid16Glyph/>;
        case 'feedback-received-solid':
          return <FeedbackReceivedSolid16Glyph/>;
        case 'status-pending':
          switch (props.size) {
            case 16:
              return <StatusPending16Glyph/>;
            default:
            case 24:
              return <StatusPending24Glyph/>;
          }
        case 'bell':
          switch (props.size) {
            case 16:
              return <Bell16Glyph/>;
            default:
            case 24:
              return <Bell24Glyph/>;
          }
        case 'status-completed':
          switch (props.size) {
            case 16:
              return isFilled ? <StatusCompletedFilled16Glyph/> : <StatusCompleted16Glyph/>;
            default:
            case 24:
              return <StatusCompleted24Glyph/>;
          }
        case 'status-running':
          switch (props.size) {
            case 16:
              return <StatusRunning16Glyph/>;
            default:
            case 24:
              return <StatusRunning24Glyph/>;
          }
        case 'previous':
          switch (props.size) {
            case 16:
              return <Previous16Glyph/>;
            default:
            case 24:
              return <Previous24Glyph/>;
          }
        case 'previous-skip':
          switch (props.size) {
            case 16:
              return <PreviousSkip16Glyph/>;
            default:
            case 24:
              return <PreviousSkip24Glyph/>;
          }
        case 'next':
          switch (props.size) {
            case 16:
              return <Next16Glyph/>;
            default:
            case 24:
              return <Next24Glyph/>;
          }
        case 'next-skip':
          switch (props.size) {
            case 16:
              return <NextSkip16Glyph/>;
            default:
            case 24:
              return <NextSkip24Glyph/>;
          }
        default:
          return null;
      }
    },
    [props.glyph, props.glyphStyle]
  );

  const isAnimated = props.glyph === 'busy';

  return (
    <div
      className={
        RenderHelpers.classes(
          styles.component,
          props.className,
          isAnimated ? styles.animated : null
        )
      }
      style={{
        fill: props.color,
        ...{'--icon-size': `${props.size}px`},
        ...props.style
      }}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
    >
      {contents}
    </div>
  );
};